import { IconButton, Box, Tooltip } from '@mui/material';
import { WbSunny as SunIcon, DarkMode as MoonIcon } from '@mui/icons-material';
import themeConfig from 'settings/branding';

interface Props {
  toggle: () => void;
  current: 'light' | 'dark';
  title: string;
}

export const SwitchTheme = ({ toggle, current, title }: Props) => {
  return (
    <Tooltip title={title}>
      <Box
        onClick={() => {
          toggle();
        }}
        sx={(theme) => ({
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          backgroundColor: themeConfig.theme.primary.light,
          borderRadius: '50px',
          padding: '2px',
          '&:hover': { backgroundColor: themeConfig.theme.primary.main + '40' },
        })}
      >
        <IconButton
          sx={(theme) => ({
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.primary.main,
            backgroundColor: current === 'dark' ? 'transparent' : theme.palette.background.paper,
            transition: 'all 0.3s ease',
            '&:hover': { backgroundColor: current === 'dark' ? 'transparent' : theme.palette.background.paper },
          })}
        >
          <SunIcon sx={{ fontSize: 20 }} />
        </IconButton>

        <IconButton
          sx={(theme) => ({
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: themeConfig.theme.primary.main,
            backgroundColor: current === 'light' ? 'transparent' : theme.palette.background.paper,
            transition: 'all 0.3s ease',
            borderRadius: '50%',
            '&:hover': { backgroundColor: current === 'light' ? 'transparent' : theme.palette.background.paper },
          })}
        >
          <MoonIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Box>
    </Tooltip>
  );
};
